// src/store/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    currentUser: null,
  },
  reducers: {
    setUser(state, action) {
      const newUser = action.payload;
      if (newUser) {
        // Preserve referralId from current state or localStorage if new user doesn't have it
        const currentReferralId = (state.currentUser as any)?.referralId;
        const savedUser =
          typeof localStorage !== "undefined"
            ? JSON.parse(localStorage.getItem("user") || "null")
            : null;
        const preservedReferralId =
          newUser.referralId || currentReferralId || savedUser?.referralId;

        // Clean out undefined values so they don't overwrite valid existing fields
        const cleanNewUser = { ...newUser };
        Object.keys(cleanNewUser).forEach((key) => {
          if (cleanNewUser[key] === undefined) {
            delete cleanNewUser[key];
          }
        });

        // Merge savedUser and previous state with new user updates so partial fetches (/personal-info) don't wipe flags
        const mergedUser = {
          ...(savedUser || {}),
          ...((state.currentUser as any) || {}),
          ...cleanNewUser,
          referralId: preservedReferralId,
        };

        // If validated or emailVerified is true, preserve as true
        if (mergedUser.validated === true || mergedUser.emailVerified === true) {
          mergedUser.emailVerified = true;
          mergedUser.validated = true;
        }

        // If phone was verified or phone number existed previously, preserve it
        if (cleanNewUser.phoneVerified === true || savedUser?.phoneVerified === true || (state.currentUser as any)?.phoneVerified === true) {
          mergedUser.phoneVerified = true;
        }
        if (!mergedUser.phoneNumber && (savedUser?.phoneNumber || (state.currentUser as any)?.phoneNumber)) {
          mergedUser.phoneNumber = savedUser?.phoneNumber || (state.currentUser as any)?.phoneNumber;
        }

        state.currentUser = mergedUser as any;
      } else {
        state.currentUser = null;
      }
    },
    logoutUser(state) {
      state.currentUser = null;
    },
  },
});

export const { setUser, logoutUser } = userSlice.actions;
export default userSlice.reducer;
